module.exports = __webpack_public_path__ + "static/media/LCD-prosessi-pysty-en.2356f1dc.svg";